import getWindow from './getWindow';
const getCurrentUrlWithoutPortalId = () => {
  try {
    const currentWindow = getWindow();
    const url = new URL(currentWindow.location.href);

    // Use the same pattern as getPortalId to identify and remove the portal ID
    // Pattern matches: /app-name/portalId/ or /app-name/portalId (at end)
    const pathWithoutPortalId = url.pathname.replace(/^(\/[A-Za-z0-9-_]*)\/\d+(\/|$)/, '$1$2');
    url.pathname = pathWithoutPortalId;
    return url.toString();
  } catch (error) {
    // Fallback to original href if URL construction fails
    return getWindow().location.href;
  }
};
export default getCurrentUrlWithoutPortalId;